module.exports = __webpack_public_path__ + "media/images/product/p_b-10f8a236eb7cd3d8f5b860a5929b1c36.png";